import styled from '@emotion/styled'

export const CCRecipientsFieldWrapper = styled.div``
